import "slick-carousel";
import "remodal";
import "jquery-match-height";
//import all js files in vendor directory
let vendors = require.context("./vendors", true, /\.js$/);
vendors.keys().forEach(vendors);

//import all js files in modules directory
let modules = require.context("./modules", true, /\.js$/);
modules.keys().forEach(modules);
